export { default as MenuParser } from './Menu';
